import { canAddTranscriber, isTranscribing } from '../transcribing/functions';
import { formatCaptionTime } from './captionLocalization';
/**
 * Whether this is an interpreted room (VRS 'vrs-', VRI 'vri-' or 'instant-'),
 * where the interpreter's voice is captioned for the Deaf caller. The CC
 * toolbar button is offered here even without Jitsi's own transcription
 * config, and a press turns captions on or off rather than asking for a
 * language. Point-to-point rooms have no voice to caption.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {boolean}
 */
export function isInterpretedCaptionRoom(state) {
    const room = state['features/base/conference']?.room;
    return typeof room === 'string'
        && (room.startsWith('vrs-') || room.startsWith('vri-') || room.startsWith('instant-'));
}
/**
 * Checks whether the participant can start the subtitles.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {boolean} - True if the participant can start the subtitles.
 */
export function canStartSubtitles(state) {
    return canAddTranscriber(state) || isTranscribing(state);
}
/**
 * Formats the local in-room caption history for transcript display/export.
 *
 * @param {ISubtitleHistoryEntry[]} entries - Caption history entries.
 * @returns {string} Plain transcript text.
 */
export function formatSubtitleHistory(entries = [], options = {}) {
    return entries.map(entry => {
        const time = formatCaptionTime(entry.timestamp, options.language);
        const speaker = entry.participantName || options.unknownSpeaker || 'Unknown speaker';
        const marker = entry.final ? '' : ` (${options.interim || 'interim'})`;
        const label = options.showSpeakerNames === false
            ? (entry.final ? '' : `(${options.interim || 'interim'})`)
            : `${speaker}${marker}`;
        return `[${time}] ${label ? `${label}: ` : ''}${entry.text}`;
    }).join('\n');
}
